import { render } from "./PHeaderNavItems.vue?vue&type=template&id=428af9fe&scoped=true"
import script from "./PHeaderNavItems.vue?vue&type=script&lang=js"
export * from "./PHeaderNavItems.vue?vue&type=script&lang=js"

import "./PHeaderNavItems.vue?vue&type=style&index=0&id=428af9fe&lang=less&scoped=true"

import exportComponent from "/builds/sqMDsSTzB/0/dsp/plazkart-interface/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-428af9fe"]])

export default __exports__